<template>
  <div class="yo-view-of-chat" :class="{ 'yo-open-menu': !openMenu }">
    <div v-if="roomID === null">
      <WelcomeToITC></WelcomeToITC>
    </div>

    <div v-else-if="show === 'setup'">
      <ChatBoxTitle @switch="(v) => { $emit('switch', v) }">
        <div slot="left">
          <!-- <img src="../img/back.svg" @click="$emit('openMenu', false)" alt="back"> -->
        </div>
        <div slot="center">
          User Setup
          <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
        </div>
        <div slot="right">
          <!-- <img src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
        </div>
      </ChatBoxTitle>

      <YourName @ready="onReady" class="marginer"></YourName>
    </div>
    <PasswordProtector v-else-if="roomID && roomID !== null && show === 'chat'" :roomID="roomID" @openMenu="(v) => { $emit('openMenu', v) }">
      <Chatty @switch="(v) => { $emit('switch', v) }"  :roomID="roomID" @openMenu="(v) => { $emit('openMenu', v) }"></Chatty>
      <!-- <div>
        View Of Chat {{ roomID }}
      </div> -->

    </PasswordProtector>

  </div>
</template>

<script>
import ChatBoxTitle from './ChatBoxTitle.vue'
import PasswordProtector from './PasswordProtector'
import YourName from '@/yoteach2-gui/parts/YourName/YourName.vue'
import { API } from '@/yoteach2-gui/parts/index.js'
import Chatty from './Chatty'

export default {
  components: {
    WelcomeToITC: () => import('./WelcomeToITC.vue'),
    Chatty,
    YourName,
    PasswordProtector,
    ChatBoxTitle
  },
  props: {
    openMenu: {
      default: false
    },
    roomID: {
      default: false
    }
  },
  data () {
    return {
      show: 'chat'
    }
  },
  mounted () {
    let chatter = API.Status.state.chatter
    let hasChatter = chatter && !!chatter.uuid
    if (!hasChatter) {
      this.show = 'setup'
    }
  },
  methods: {
    onReady () {
      this.show = 'chat'
    }
  }
}
</script>

<style scoped>
.yo-view-of-chat{
  width: 100%;
  display: none;
  height: 100%;
  overflow: auto;
  /* -webkit-overflow-scrolling: touch;
  background-color: #f3f3f3; */
}
@media screen and (min-width: 767px){
  .yo-view-of-chat{
    display: block;
    width: calc(100% - 248px - 55px);
  }
}
.yo-view-of-chat.yo-open-menu{
  display: block;
}
.marginer{
  margin: 30px;
}

.all-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
